<template>
  <div>
    <div>
      <HomeVueAq v-if="view == 'home' && $store.getters.get_company.id == 3" />
      <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 1" />
      <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 4" />
      <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 6" />
      <HomeCarbinoVue v-if="view == 'home' && $store.getters.get_company.id == 5" />
      
      <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />

      <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 1" />
      <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 4" />
      <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 6" />
      <CloseBeadAqVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 3" />
      <CloseBeadCarbinoVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 5" />

      
      <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
      <ReportView v-if="view == 'reports'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
    </div>
    <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
  </div>
</template>

<script>
import FooterVue from "../../components/administrador/demo/Footer.vue";
import HomeVue from "../../components/administrador/demo/Home.vue";
import HomeVueAq from "../../components/administrador/aq/Home.vue";
import HomeCarbinoVue from "../../components/administrador/carbino/Home.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import CloseBeadVue from "../../components/caja/demo/page/CloseBead.vue";
import CloseBeadAqVue from "../../components/caja/aq/page/CloseBead.vue";
import CloseBeadCarbinoVue from "../../components/caja/carbino/page/CloseBead.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import ReportView from '../reports/ReportsView.vue';


export default {
  components: { FooterVue, HomeVue, MaintenanceVue, CloseBeadVue, ProccessVue, ReportView,CloseBeadAqVue,CloseBeadCarbinoVue, HomeVueAq, HomeCarbinoVue },
  data() {
    return {
      view: "home",
      booFooter: true
    };
  },
  methods: {
    setView: function (payload) {
      this.view = payload;
    },
    mtdViewFooter: function (boo, view) {
      this.booFooter = boo;
      if (boo == true) this.view = view;
    }
  },
};
</script>

<style lang="scss" scoped></style>
